import api from "../api";

// Safety Incidents 
export const getSafetyIncidents = (params) =>
 api.get("/safety", { params });

export const getSafetyIncident = (id) =>
 api.get(`/safety/${id}`);

export const createSafetyIncident = (data) =>
 api.post("/safety", data, {
 headers: { "Content-Type": "multipart/form-data" },
 });

export const updateSafetyIncident = (id, data) =>
 api.patch(`/safety/${id}`, data, {
 headers: { "Content-Type": "multipart/form-data" },
 });

export const deleteSafetyIncident = (id) =>
 api.delete(`/safety/${id}`);

// Workflow 
export const resolveSafetyIncident = (id, data) =>
 api.patch(`/safety/${id}/resolve`, data);

export const closeSafetyIncident = (id, data) =>
 api.patch(`/safety/${id}/close`, data);

export const updateCorrectiveAction = (id, actionId, data) =>
 api.patch(`/safety/${id}/corrective-actions/${actionId}`, data);

// Stats & Reports 
export const getSafetyStats = (params) =>
 api.get("/safety/stats", { params });

export const generateSafetyReport = (params) =>
 api.get("/safety/report", { params });
